import axios from 'axios'

export const getLevel = async (id) =>
    await axios.get(`${process.env.REACT_APP_API}tankLevel/${id}`);

export const getAllLevels = async () =>
    await axios.get(`${process.env.REACT_APP_API}tankLevel/`);
